// extracted by mini-css-extract-plugin
export default {"container":"UpdateHint_container__Fqqs-","heading":"UpdateHint_heading__fJzOw","subheading":"UpdateHint_subheading__JUKpx"};